<template>
  <div class="separation">
    <hr class="holes" />
  </div>
</template>

<script>
export default {
  name: 'HoleSeparation'
}
</script>

<style lang="scss" scoped>
.separation {
  position: relative;
  height: 13.5px;
  margin: 1.5em 0;
}

.holes {
  margin: 0;
  border: none;
  background-image: url('~@/assets/images/dot.png');
  background-repeat: repeat-x;
  background-size: 21px 14px;
  position: absolute;
  left: -18px;
  right: -18px;
  top: 0;
  background-position: top center;
  height: 14px;
  top: 0;
}
</style>
